import Indicator from '../Indicator';

/** Dividend Yield indicator */
export default class DividendYieldIndicator extends Indicator {
	/**
	 * Returns the default params for this type of indicator. Overrides abstract
	 * method inherited from Indicator.
	 * @returns {object} - Default parameters object
	 * @property {String} id - Indicator ID
	 * @property {String} name - Indicator name
	 * @property {String} description - Indicator description
	 */
	_getDefaultParams() {
		return {
			id: 'dividendyield',
			name: 'Dividend Yield',
			description: 'Dividend Yield is the dividend per share divided by the price per share.',
			componentSeries: [
				{ id: 'dividendyield' }
			]
		};
	}

	/** @param {Object} data - Symbol data object */
	render(data, sessionType) {
		this._renderLineMarker({
			data: data[this.params.id],
			sessionType
		});
	}
}
